import * as query from '@arcgis/core/rest/query';
import { ILogRecordAttributes, mapControllerVerification } from '../../controllers/MapControllerVerification';
import { OperationType } from '../../controllers/genusTableController';

interface IQueryParams {
  where: string;
  outFields?: string[];
  returnGeometry?: boolean;
  returnDistinctValues?: boolean;
}

export enum AnalysisType {
  Verification = 'Verification',
  Determination = 'Determination',
}
export interface ICreateLogRecord {
  hashMap: Map<string, string>;
  featureUrl: string;
  analysisID: string;
  username: string;
  type: AnalysisType;
  ClaimedLocation: string | null;
  certificationStatus?: string;
}

export const queryFeatures = async (queryParams: IQueryParams, url: string) => {
  const params = {
    ...queryParams,
  };

  try {
    const response = await query.executeQueryJSON(url, params);
    return {
      success: true,
      data: response,
    };
  } catch (err) {
    console.error('err', err);
    return {
      success: false,
      message: err,
      data: null,
    };
  }
};

/*
 * @description: This function is used to create a log record each time the analysis is run for the verification and determination analysis
 * */
export const createLogRecord = async (params: ICreateLogRecord) => {
  const { hashMap, featureUrl, analysisID, username, type, ClaimedLocation, certificationStatus } = params;

  const idJsonFileName = `${analysisID}.json`;
  const logAttributes = {
    UploadDate: new Date().toISOString(),
    OrderNumber: hashMap.get('Order number') || '',
    UserName: username,
    FeatureService: featureUrl,
    GeoJson: idJsonFileName,
    UniqueID: analysisID,
    AnalysisType: type,
    ClaimedLocation,
    CertificationStatus: certificationStatus,
  } as ILogRecordAttributes;

  await mapControllerVerification.createReportLogRecord({ logAttributes, type: OperationType.Add });
};
